import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9f4155e6")

_pushScopeId("data-v-9f4155e6")
const _hoisted_1 = { class: "admin-contract-users" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "header" }, [
  /*#__PURE__*/_createVNode("h3", { class: "title" }, "ユーザー一覧")
], -1)
const _hoisted_3 = { class: "contract" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { class: "title" }, "会社名：", -1)
const _hoisted_5 = { class: "value" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { class: "title" }, "部署名（任意）：", -1)
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "header" }
const _hoisted_9 = /*#__PURE__*/_createVNode("h3", { class: "title" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "ユーザ追加", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AdminContractUserItem = _resolveComponent("AdminContractUserItem")
  const _component_AdminContractUserEdit = _resolveComponent("AdminContractUserEdit")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("label", _hoisted_5, _toDisplayString(_ctx.contract.companyName), 1),
      _hoisted_6,
      _createVNode("label", _hoisted_7, _toDisplayString(_ctx.contract.optionName), 1)
    ]),
    _createVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode("button", {
        class: "primary-button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toCreate && _ctx.toCreate(...args)))
      }, [
        _hoisted_10
      ])
    ]),
    _createVNode(_component_AdminContractUserItem, { isHeader: true }),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
      return (_openBlock(), _createBlock(_component_AdminContractUserItem, {
        class: "list-item",
        key: user.id,
        item: user,
        onEdit: _ctx.toEdit,
        onDanger: _ctx.toDelete
      }, null, 8, ["item", "onEdit", "onDanger"]))
    }), 128)),
    _createVNode(_component_AdminContractUserEdit, {
      isShowModal: _ctx.isShowEdit,
      "onUpdate:isShowModal": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowEdit = $event)),
      isDeleteMode: _ctx.isDeleteMode,
      editModel: _ctx.editingModel,
      apply: _ctx.apply,
      onRemove: _ctx.remove
    }, null, 8, ["isShowModal", "isDeleteMode", "editModel", "apply", "onRemove"])
  ]))
})